import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthService} from '../../../../services/auth.service';
import {Subscription} from 'rxjs';
import {StorageService} from '../../../../services/storage-service.service';
import {UserTypeEnum} from '../../../interfaces/data.interfaces';
import {TranslateService} from '@ngx-translate/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  staffLoginForm: UntypedFormGroup;
  loading = false;
  subscription: Subscription = new Subscription();
  hide: boolean;
  resetPwdForm: UntypedFormGroup;
  showPassword = false;


  errorMessage: string | null = null;
  errorStatus: number | null = null;

  constructor(
    private dialogRef: MatDialogRef<LoginComponent>,
    private fb: UntypedFormBuilder,
    private route: Router,
    private auth: AuthService,
    private storageService: StorageService,
    public translate: TranslateService
  ) {
    this.hide = true;
  }

  ngOnInit(): void {
    this.staffLoginForm = this.fb.group({
      username: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]]
    });
    this.resetPwdForm = this.fb.group({
      email: [null]
    });
  }

  async login() {
    this.loading = true;
    try {
      await this.auth.login(this.staffLoginForm.value);
      await this.auth.authRole();
       const category = this.storageService.get('userType');

      if (category){
        console.log('this is user category',category);
        if (category === UserTypeEnum.INTERNAL) {
          console.log('anaenda kwa admin');
          // await this.route.navigate(['', 'online-layout']);
          await this.route.navigate(['', 'dashboard']);
        } else {
          console.log('inside');
          await this.route.navigate(['', 'home']);
        }
      } else {
        await this.route.navigate(['', 'login']);
      }

       this.close();
    } catch (e) {
    }
    this.loading = false;
  }

  // async login() {
  //   this.loading = true;
  //   // Clear previous errors before attempting a new login
  //   this.errorMessage = null;
  //   this.errorStatus = null;
  //
  //   try {
  //     await this.auth.login(this.staffLoginForm.value);
  //     await this.auth.authRole();
  //     const category = this.storageService.get('userType');
  //
  //     if (category) {
  //       if (category === UserTypeEnum.INTERNAL) {
  //         await this.route.navigate(['', 'dashboard']);
  //       } else {
  //         console.log('inside');
  //         await this.route.navigate(['', 'homes']);
  //       }
  //     } else {
  //       await this.route.navigate(['', 'login']);
  //     }
  //
  //     // this.close(); // Assuming this is a modal close function
  //   } catch (e) {
  //     console.error('Login attempt failed:', e);
  //     // @ts-ignore
  //     const authError = e as CustomAuthError;
  //
  //     if (authError && authError.statusCode) {
  //       // Status code is available (e.g., 401)
  //       this.errorStatus = authError.statusCode;
  //       this.errorMessage = authError.message; // This will hold "Invalid credentials"
  //     } else {
  //       // Fallback for unexpected or network errors (status 0)
  //       this.errorStatus = 0;
  //       this.errorMessage = 'A network or unexpected error occurred. Please try again.';
  //     }
  //   }
  //   this.loading = false;
  // }

  toggleLoginPassword() {
    if (this.hide) {
      this.hide = false;
      this.resetPwdForm.controls.email.setValidators([Validators.required, Validators.email]);
    } else {
      this.hide = true;
      this.resetPwdForm.controls.email.clearValidators();
    }
    this.resetPwdForm.controls.email.updateValueAndValidity();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  submitResetPassword(formData: any) {
    this.auth.generateResetLink( formData.email);
  }

  close(){
    this.dialogRef.close();
  }

}
